import { db } from './firebase';
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';

const docRef = doc(db, 'linktreeLinks', 'main');

export function subscribeLinks(callback) {
  // Real-time listener
  return onSnapshot(docRef, (docSnap) => {
    if (docSnap.exists()) {
      callback(docSnap.data().links || []);
    } else {
      callback([]);
    }
  });
}

export async function getLinks() {
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return docSnap.data().links || [];
  }
  return [];
}

export async function setLinks(links) {
  await setDoc(docRef, { links });
} 